import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { Route, Switch } from 'react-router-dom';
import { About } from './pages/about';
import { Research } from './pages/research';
import { Publications } from './pages/publications';
import { Projects } from './pages/projects';
import { Work } from './pages/work';
import { Teaching } from './pages/teaching';
import { People } from './pages/people';
import { Contact } from './pages/contact';
import { Patent1 } from './pages/patents/patent1';
import { Patent2 } from './pages/patents/patent2';
import { Discussion1 } from './pages/patents/discussion1';
import { Discussion2 } from './pages/patents/discussion2';
import { Discussion3 } from './pages/patents/discussion3';
import { Journal1 } from './pages/patents/journal1';
import { Journal2 } from './pages/patents/journal2';
import { Project1 } from './pages/patents/project1';
import { Work1 } from './pages/patents/work1';
import { Work2 } from './pages/patents/work2';
import { Work3 } from './pages/patents/work3';
import { Work4 } from './pages/patents/work4';
import { Education } from './pages/education';

function App() {
    return (
        <main>
            <Switch>
                <Route exact path="/" component={ About } />
                <Route exact path="/about" component={ About } />
                <Route exact path="/research" component={ Research } />
                <Route exact path="/research/patent1" component={ Patent1 } />
                <Route exact path="/research/patent2" component={ Patent2 } />
                <Route exact path="/research/discussion1" component={ Discussion1 } />
                <Route exact path="/research/discussion2" component={ Discussion2 } />
                <Route exact path="/research/discussion3" component={ Discussion3 } />
                <Route exact path="/research/journal1" component={ Journal1 } />
                <Route exact path="/research/journal2" component={ Journal2 } />
                <Route exact path="/research/project1" component={ Project1 } />
                <Route exact path="/research/work1" component={ Work1 } />
                <Route exact path="/research/work2" component={ Work2 } />
                <Route exact path="/research/work3" component={ Work3 } />
                <Route exact path="/research/work4" component={ Work4 } />
                <Route exact path="/publications" component={ Publications } />
                <Route exact path="/projects" component={ Projects } />
                <Route exact path="/work" component={ Work } />
                <Route exact path="/education" component={ Education } />
                <Route exact path="/mentoring" component={ Teaching } />
                <Route exact path="/people" component={ People } />
                <Route exact path="/contact" component={ Contact } />
            </Switch>
        </main>
    )
}

export default App;